import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import { validate } from "./validate";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import { Row } from "../password/UIComponents";
import Phone from "./phoneNumberFields";
import Address from "./addressFields";
import MuiTextInput from "../../Common/MuiTextInput";
import { Button } from "@mantine/core";

const useStyles = makeStyles((theme) => ({
  submit: {
    marginTop: "16px",
    borderTop: `1px solid ${theme.app.borderColor}`,
    padding: "8px 0",
    display: "grid",
    gridTemplateColumns: "1fr auto",
    alignItems: "center",
  },
  formActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    "& button": {
      marginLeft: "8px",
    },
  },
  button: { color: theme.app.labelColor },
}));

const CustForm = (props) => {
  const [canEditForm, setCanEditForm] = useState(false);
  const { handleSubmit, language, initialValues, activePerson } = props;
  const classes = useStyles();

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, actions) =>
        handleSubmit(values, actions, () => setCanEditForm(!canEditForm))
      }
      validate={(values) => validate(values, language)}
      enableReinitialize={true}
      render={(props) => (
        <Form>
          <Row cols={2}>
            <Field
              component={MuiTextInput}
              fullWidth={true}
              label={language.Account_FirstName.Label}
              name="firstname"
              placeholder={language.Account_FirstName.Placeholder}
              type="text"
              disabled={!canEditForm}
              autocomplete="given-name"
            />
            <Field
              component={MuiTextInput}
              fullWidth={true}
              label={language.Account_LastName.Label}
              name="lastname"
              placeholder={language.Account_LastName.Placeholder}
              type="text"
              disabled={!canEditForm}
              autocomplete="family-name"
            />
          </Row>
          <Row cols={2}>
            <Field
              component={MuiTextInput}
              fullWidth={true}
              label={language.Account_Email.Label}
              name="email"
              placeholder={language.Account_Email.Placeholder}
              type="text"
              disabled={!canEditForm}
              autocomplete="mail"
            />
            <Field
              component={MuiTextInput}
              fullWidth={true}
              label={language.Account_CivicRegistrationNumber.Label}
              name="civicRegistrationNumber"
              placeholder={language.Account_CivicRegistrationNumber.Placeholder}
              type="text"
              disabled={!canEditForm}
            />
          </Row>
          <Row
            cols={
              activePerson.phonenumbers.length > 1
                ? activePerson.phonenumbers.length
                : 2
            }
          >
            {activePerson.phonenumbers.map((p, i) => {
              return (
                <Phone
                  p={p}
                  i={i}
                  language={language}
                  key={i}
                  canEditForm={canEditForm}
                />
              );
            })}
          </Row>
          {activePerson.addresses.length < 1 ? (
            <Row>
              <Address canEditForm={canEditForm} i={0} language={language} />
            </Row>
          ) : (
            activePerson.addresses.map((a, i) => {
              return (
                <Row key={i}>
                  <Address
                    a={a}
                    i={i}
                    language={language}
                    canEditForm={canEditForm}
                  />
                </Row>
              );
            })
          )}
          <div className={classes.submit}>
            <div>
              <Button
                className={classes.button}
                onClick={() => window.history.back()}
                variant="subtle"
                color="dark"
              >
                Tillbaka
              </Button>
            </div>
            <div className={classes.formActions}>
              <Button
                type="button"
                color="dark"
                variant="subtle"
                className={classNames(
                  classes.button,
                  "customer-info__edit-button"
                )}
                onClick={
                  canEditForm
                    ? () => {
                        setCanEditForm(false);
                        props.handleReset();
                      }
                    : () => setCanEditForm(!canEditForm)
                }
              >
                {canEditForm ? language.Reset : language.Edit}
              </Button>
              <Button
                disabled={!props.isValid || props.isSubmitting || !canEditForm}
                type="submit"
                className={classNames(
                  classes.submitButton,
                  "customer-info__submit-button primaryButton"
                )}
              >
                {language.Save}
              </Button>
            </div>
          </div>
        </Form>
      )}
    />
  );
};

export default CustForm;
